import type { MessageDescriptor } from 'react-intl'
import { defineMessages } from 'react-intl'

export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS = 7_500
export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS = 100

const campaignLabelMessages = defineMessages({
  static: {
    id: '46Kc2-OXvP2ZiSjsiIUS',
    defaultMessage: 'Bonus points',
    description: 'Form field label for static bonus points campaign type',
  },
  double: {
    id: 'e3qJEmGkvjsfonqDtflC',
    defaultMessage: 'Double points',
    description: 'Label for double points campaign type in the loyalty program section',
  },
  doubleStatusCredits: {
    id: 'jPC2qTXEKzZI4DeXyc2-',
    defaultMessage: 'Double status credits',
    description: 'Form field label for double status credits campaign type',
  },
  triple: {
    id: '94stKKOxUQbIM49w5n4n',
    defaultMessage: 'Triple points',
    description: 'Label for triple points campaign type in the loyalty program section',
  },
})

export const LOYALTY_BONUS_POINTS_CAMPAIGN_LABEL: Record<App.LoyaltyBonusPointsCampaignType, MessageDescriptor> = {
  static: campaignLabelMessages.static,
  double: campaignLabelMessages.double,
  double_status_credits: campaignLabelMessages.doubleStatusCredits,
  triple: campaignLabelMessages.triple,
}
